import { PlatformLanguage } from "@/generated-api/models/PlatformLanguage";
import { useGetAccountSettings } from "@/tanstack-hooks";
import { TRANSLATIONS } from "@/translations";

export const useTranslation = () => {
  const { data } = useGetAccountSettings();
  // Default to English if settings aren't loaded yet
  const language = data?.preferred_language || PlatformLanguage.ENGLISH;
  // Get translations for the current language with fallback to English
  return TRANSLATIONS[language] || TRANSLATIONS[PlatformLanguage.ENGLISH];
};
